import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CommentButtonProps {
  commentCount: number;
  onClick: () => void;
  size?: 'sm' | 'default';
}

export function CommentButton({ 
  commentCount, 
  onClick,
  size = 'sm'
}: CommentButtonProps) {
  return (
    <Button
      variant="ghost"
      size={size}
      onClick={onClick}
      className="flex items-center gap-1.5 px-3 text-muted-foreground hover:text-foreground transition-colors touch-target tap-feedback"
    >
      <MessageCircle className="w-5 h-5" />
      {commentCount > 0 && (
        <span className="text-sm font-medium tabular-nums">
          {commentCount}
        </span>
      )}
    </Button>
  );
}